import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import cross from "../Assets/cross.png";
import img from "../Assets/Group 1000002189.png";
import {
  addToCart,
  getWishlistByUser,
  removeFromWishlist,
  moveToCart
} from "../Common/apis";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader.jsx";
import { useNavigate } from "react-router-dom";
import Navbar2 from "../Components/Navbar2.jsx";
import Footer2 from "../Components/Footer2.jsx";
import Aos from "aos";

function Wishlist() {
  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once
    });
  }, []);
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("GISUL_TOKEN");

  useEffect(() => {
    fetchWishlist();
  }, []);

  const fetchWishlist = async () => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      const response = await getWishlistByUser();
      setWishlist(response?.data?.courses || []);
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRemove = async (courseId) => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      await removeFromWishlist({ courseId });
      fetchWishlist();
    } catch (error) {
      console.error("Error removing from wishlist:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleMoveToCart = async (courseId) => {
    if (!token) {
      toast.error("Please login.");
      navigate("/login");
      return;
    }
    setLoading(true);
    try {
      await moveToCart({ courseId });
      fetchWishlist();
      toast.success("Moved to cart successfully!");
    } catch (error) {
      console.error("Error moving to cart:", error);
      toast.error("Failed to move to cart");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`new-home ${wishlist.length === 0 ? "h-[100vh]" : "h-auto"}`}>
      <Navbar2 />
      {loading ? <Loader /> : null}
      <div data-aos="fade-up" className="new-home-center new-home-center2">
        <h2>Your Wishlist</h2>
        <p>({wishlist.length || 0} Items)</p>
      </div>
      <div className="cart-div overflow-hidden">
        {wishlist.length === 0 ? (
          <>
            <p style={{ fontFamily: "DM sans, serif" }} className="font-[400] md:text-left text-center sm:text-[20px] text-[16px] leading-[26px] text-[#FFFFFF] px-[30px]">Your wishlist is empty.</p>
            {wishlist.length === 0 &&
              <div className="pb-[250px]"></div>
            }
          </>

        ) : (
          wishlist.map((item) => (
            <div className="w-full" key={item._id}>
              {/* this is desktop view  */}
              <div className="md:flex hidden w-full">
                <div className="cart-section" key={item._id}>
                  <div className="flex items-center gap-[24px] overflow-hidden">
                    <div data-aos="fade-right" style={{ background: "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)" }} className="rounded-[12px] py-[22px] px-[22px] overflow-hidden">
                      <img className="cart-img" src={(item?.images?.length > 0 && item?.images[0]) || img} alt={item.name} style={{}} />
                    </div>
                    <div data-aos="fade-left" className="flex flex-col gap-[16px]">
                      <h3>{item.name}</h3>
                      <p>${item.price}</p>
                    </div>
                  </div>
                  <div>
                    <button
                      data-aos="fade-right"
                      className="bg-[#F1E60D] rounded-[12px] py-[12px] px-[20px] font-sans font-[400] text-[16px] text-[#263238]"
                      onClick={() => handleMoveToCart(item._id)}
                    >
                      Move to Cart
                    </button>
                  </div>
                  <div className="remover-btn-div">
                    <img
                      data-aos="fade-left"
                      src={cross}
                      alt="Remove"
                      onClick={() => handleRemove(item._id)}
                      style={{ cursor: "pointer" }}
                      className="remove-btn"
                    />
                  </div>
                </div>
              </div>
              {/* this is mobile view  */}
              <div className="md:hidden flex w-full">
                <div className="cart-section" key={item._id}>
                  <div className="flex items-center md:gap-[24px] gap-[12px] overflow-hidden">
                    <div data-aos="fade-right" style={{ background: "linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(243, 220, 186, 0.7) 100%)" }} className="rounded-[12px] py-[22px] px-[22px]">
                      <img className="cart-img" src={(item?.images?.length > 0 && item?.images[0]) || img} alt={item.name} style={{}} />
                    </div>
                    <div data-aos="fade-left" className="flex flex-col items-start gap-[1px]">
                      <h3>{item.name}</h3>
                      <p>${item.price}</p>
                      <button
                        data-aos="fade-right"
                        className="bg-[#F1E60D] rounded-[12px] py-[12px] px-[20px] font-sans font-[400] text-[16px] text-[#263238]"
                        onClick={() => handleMoveToCart(item._id)}
                      >
                        Move to Cart
                      </button>
                    </div>
                  </div>
                  <div className="">
                    <img
                      data-aos="fade-left"
                      src={cross}
                      alt="Remove"
                      onClick={() => handleRemove(item._id)}
                      style={{ cursor: "pointer" }}
                      className="h-[34px] w-[34px] mr-[16px]"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      <Footer2 />
    </div>
  );
}

export default Wishlist;